<div class="flex min-h-80 flex-col px-6 xl:w-8/12">
  <div class="items-center justify-between md:flex">
    <h2 class="mt-5 text-[25px] font-bold text-primary-normal xl:text-[26px]">
      Histórico de pagos
    </h2>
    <div class="mt-5">
      <app-search-filter
        placeholdertext="Número de recibo"
        [filters]="filters"
        [filterLogic]="filterLogic"
      ></app-search-filter>
    </div>
  </div>
  @if (filteredByDate) {
    <h3 class="mt-5 text-lg font-semibold text-secondary-strong xl:text-[21px]">
      Recibos desde
      <span class="font-bold text-primary-normal">{{
        startDate | date: "dd/MM/yyyy"
      }}</span>
      hasta
      <span class="font-bold text-primary-normal">{{
        endDate | date: "dd/MM/yyyy"
      }}</span>
    </h3>
  } @else {
    <h3 class="mt-5 text-lg font-semibold text-secondary-strong xl:text-[21px]">
      Recibos en el último año
    </h3>
  }

  <!-- Paginated Receipts -->
  @if (filteredReceipts && filteredReceipts.data.receipts.length > 0) {
    <div class="mt-5 flex flex-col space-y-4">
      @for (receipt of getPaginatedItems(); track receipt) {
        <app-payment-history-card
          [receipt]="receipt"
          [numberOfReceipts]="receipt.numberOfReceipts"
        >
          ></app-payment-history-card
        >
      }
    </div>
  }

  <!-- No Receipts Message -->
  @if (!filteredReceipts || filteredReceipts.data.receipts.length === 0) {
    <div class="mt-10 text-center text-sm italic text-primary-subtle">
      No se encontraron recibos.
    </div>
  }

  <!-- Pagination Controls -->
  <div class="my-5 flex items-center justify-center space-x-2">
    <!-- Previous Button -->
    <button
      class="rounded-full p-2 hover:bg-[#012169] hover:bg-opacity-[8%] disabled:cursor-not-allowed"
      [disabled]="currentPage === 1"
      (click)="changePage(currentPage - 1)"
    >
      <img
        src="assets/icons/chevron-right-icon-gray.svg"
        alt="arrow left"
        class="rotate-180"
      />
    </button>

    <!-- Pagination Info -->
    <div class="flex items-center text-sm font-semibold text-secondary-strong">
      Página
      <span
        class="shadow-sm mx-3 flex h-6 w-6 items-center justify-center rounded-full bg-gray-100 font-bold text-secondary-strong"
        >{{ currentPage }}</span
      >
      de
      <span
        class="shadow-sm mx-3 flex h-6 w-6 items-center justify-center rounded-full bg-gray-100 font-bold text-secondary-strong"
        >{{ totalPages }}</span
      >
    </div>

    <!-- Next Button -->
    <button
      class="rounded-full p-2 hover:bg-[#012169] hover:bg-opacity-[8%] disabled:cursor-not-allowed"
      [disabled]="currentPage === totalPages"
      (click)="changePage(currentPage + 1)"
    >
      <img src="assets/icons/chevron-right-icon-gray.svg" alt="arrow right" />
    </button>
  </div>
</div>
